import React from 'react';
import { Link } from 'react-router-dom';
import { Eye, Calendar } from 'lucide-react';
import { Badge } from './ui/badge';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';
const FALLBACK_IMAGE = 'https://images.unsplash.com/photo-1585829365295-ab7cd400c167?w=800&h=600&fit=crop';

const NewsCard = ({ article }) => {
  const getImageUrl = (url) => {
    if (!url) return FALLBACK_IMAGE;
    if (url.startsWith('http')) return url;
    if (url.startsWith('/api/uploads') || url.startsWith('/uploads')) return `${API_URL}${url}`;
    return url;
  };

  return (
    <Link to={`/article/${article.id}`} className="block group">
      <div className="bg-white rounded-lg overflow-hidden shadow hover:shadow-lg transition-all duration-300">
        {/* Image */}
        <div className="relative h-48 overflow-hidden bg-gray-100">
          <img
            src={getImageUrl(article.image_url || article.image)}
            alt={article.title_english || article.titleEnglish}
            className="w-full h-full object-contain transform group-hover:scale-105 transition-transform duration-500"
            onError={(e) => { e.target.src = FALLBACK_IMAGE; }}
          />
          {(article.is_breaking || article.isBreaking) && (
            <div className="absolute top-3 left-3">
              <Badge className="bg-red-600 text-white px-2 py-1 text-xs font-bold uppercase">
                Breaking
              </Badge>
            </div>
          )}
        </div>

        {/* Content */}
        <div className="p-4">
          <div className="flex items-center space-x-2 mb-2">
            <Badge variant="outline" className="text-xs px-2 py-0.5 border-red-600 text-red-600">
              {article.category_bengali || article.categoryBengali || article.category}
            </Badge>
            {article.location && <span className="text-xs text-gray-500">{article.location}</span>}
          </div>
          <h3 className="text-lg font-bold text-gray-900 mb-2 line-clamp-2 group-hover:text-red-600 transition-colors duration-200">
            {article.title_bengali || article.titleBengali}
          </h3>
          <div className="flex items-center justify-between text-xs text-gray-500">
            <div className="flex items-center space-x-1">
              <Calendar className="w-3 h-3" />
              <span>{article.date || new Date(article.created_at).toLocaleDateString()}</span>
            </div>
            <div className="flex items-center space-x-1">
              <Eye className="w-3 h-3" />
              <span>{article.views || 0}</span>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default NewsCard;